import * as React from 'react';
import { useHistory } from 'react-router-dom';

export const useRedirectCallback = (url: string) => {
  const history = useHistory();
  return React.useCallback(() => {
    history.push(url);
  }, [history, url]);
};
